import * as types from 'legacy/src/constants/types';

export const flagList = {
  areFeatureFlagsLoaded: false,
  page_footer: false,
  mobile_assessment: false,
  enable_preap_pdf_printing: false,
  show_attestation_confirmation_dialog: false,
  ProgressDashboard_GroupParticipation: false,
  ProgressDashboard_SkillSummary: false,
  ProgressDashboard_TopicSummary: false,
  ProgressDashboard_UserStatus: false,
  secure_browser: false,
  secure_browser_preap: false,
  course_summary_points_possible: true,
  course_summary_export_button: false,
  student_progress_hide_not_started: true,
  live_status_report: false,
  edit_existing_question: false,
  show_usage_tab_for_admins_coords: false,
  TeacherAuthor_FRQCreate: false,
  final_exam_restriction_modal: false,
  'FY-9219-teacher-annotation': false,
  enable_stimulus_filter_on_qb_create: false,
  preap_finalexam_summary: false,
  preap_finalexam_questionlevel: false,
  prior_students: false,
  qb_elastic_search_items_create: true,
  qb_elastic_search_items_full_text: true,
  remove_action_column: true,
  questions_list_skill_column: false,
  qb_print_preview: false,
  sso_logs: false,
  remove_question_from_preview: false,
  enable_quiz_auto_save: false,
  cb_session_expiration_threshold: 90,
  cb_session_expiration_time: 5,
  cb_session_expiration_check_before_take_assignment: false,
  cb_session_expiration_check: true,
  charm_update: false,
  ppc_custom_name: false,
  charm_update_preap: false,
  show_frq_responses: false,
  show_frq_responses_student: false,
  show_updated_attestation_dialog: false,
  cb_session_expiration_logout_check: false,
  answer_sheet_response_upload_button: false,
  qb_create_add_all: false,
  preap_branding: false,
  copy_assignment_details: false,
  student_practice_mobile_nav: false,
  show_student_practice_tabs: false,
  show_student_practice_icon: false,
  to_do_student_practice: false,
  multisubjectschool_export: false,
  paperscorer_answer_sheets: false,
  show_assessment_practice_icon: false,
  student_practice_blank_message_and_order: false,
  preap_yoy: false,
  enable_audio_playback_complete: false,
  student_practice_results: false,
  preap_show_unit_tab_pathway: false,
  scoring_rubric_cumulative_score: false,
  show_education_period_filter: false,
  scoring_rubric_disable_auto_save_on_review: false,
  AP_AY_dropdown_at_top: false,
  hide_csp_outline: true,
  yoy_results: false,
  show_global_nav: false,
  quiz_builder: false,
  fy_13178_show_new_exam_alignment_text: false,
  student_save_button: false,
  ap_assign_manage_dropdowns: false,
  preap_assign_manage_dropdowns: false,
  icon_preview_update: false,
  show_gray_top_right_preview_player: false,
  edit_cb_provided_question: false,
  show_appcues_in_app_help: false,
  assessments_inform_instruction: false,
  double_arrow: false,
  // see https://academicmerit.atlassian.net/browse/FY-14979
  levity_use_createtime: false,
  AP_outline_search: false,
  preap_outline_search: false,
  pacing: false,
  review_mode: false,
  results_distractors: false,
  show_lab_edition_downloads: false,
  show_related_videos_carousel: false,
  secure_firewall_check_interval_duration_hours: 24,
  secure_firewall_check_enable: true,
  assignment_manage_classes_dropdown: false,
  show_related_videos: false,
  student_coursesummary_detail: false,
  edit_existing_question_frq: false,
  ap_daily_videos_admin_usage: false,
  show_0pct_watched: false,
  copy_assessments: false,
  outline_search_ppcs: false,
  outline_search_pdfs: false,
  outline_search_topic_questions: false,
  attestation_update_july_2020: false,
  AP_portfolio_courses_outline_search: false,
  individual_student_assignment: false,
  outline_search_type_dropdown: false,
  preap_outline_use_resources_route: false,
  show_preap_ebook_links: false,
  assignment_controls_dropdown: false,
  outline_search_instructional_resource_search_text: false,
  reorder_questions: false,
  edit_question_assessment: false,
  iPad_LDB_message: false,
  teacher_submit_unsubmit: false,
  progress_actions_dropdown: false,
  action_button: false,
  ap_teacher_impersonates_student: false,
  preap_teacher_impersonates_student: false,
  preap_quick_tips: false,
  assign_to_popover_default_opened: false,
  PS_links_in_actions_dropdown: false,
  PS_download_AS_link: false,
  PS_show_tips: false,
  paperscorer_allow_unsubmit: false,
  show_paperscorer_progress: false,
  ap_live_to_do: false,
  reshape_two_column_questions: false,
  reshape_two_column_questions_preap: false,
  copy_question_assessment: false,
  preap_chameleon_app: false,
  show_ap_stories_in_user_menu: false,
  assign_all_videos: false,
  show_video_mark_complete: false,
  export_all_assignments: false,
  results_other_tag_columns: false,
  ap_edit_quiz_in_preview: false,
  assign_all_videos_remove_x: false,
  show_my_assignments_date_picker: false,
  qb_filter_include_options: false,
  show_qb_build_quiz_most_recent_unassigned: false,
  poc_qb_preview_approach_gama: false,
  hometq_preview_approach_gama: false,
  toast_notification_autoclose: 3000,
  student_okta: false,
  cr_show_practice_exams: false,
  mastery_report: true,
  ap_qb_preview_load_more: 3,
  student_practice_problems: false,
  results_assignment_actions: false,
  qb_list_column_popover: false,
  ps_multipage_frq_responses: false,
  support_live_chat: false,
  my_assignment_page_size: 30,
  enable_appcues_student_spp: false,
  qb_list_sort_priority: false,
  disable_ppc_auto_assign: false,
  spp_filter_by_school: false,
  spp_filter_by_subject: false,
  question_bank_tabs: false,
  shared_assessments: false,
  shared_quiz_icons: false,
  shared_assessments_manage: false,
  spp_hide_assignment_progress: false,
  students_see_teacher_created: false,
  dab_for_pe_p1: false,
  internal_dab_ui: false,
  save_report_dab: false,
  retire_qb_questions: false,
  use_self_hosted_mathjax: false,
  heap_enabled: false,
  heap_for_students_enabled: false,
  scramble_questions_per_student: false,
  preap_sso_professional_learning: false,
  hide_pl_links_for_preap: false,
  teacher_organize: false,
  two_level_qb_filter: false,
  qb_cached_lrn_questions_limit: 30,
  assigned_popover: false,
  ap_sources: false,
  hierachical_qb_filters: false,
  my_assignments_pdf: false,
  labels_dnd: false,
  teacher_organize_reorder: false,
  no_reload_remove_label: false,
  qb_question_set_support: false,
  show_hide_welcome_to_ap_classroom: false,
  show_maintenance_page: false,
  no_reload_update_label: false,
  individual_student_assignment_settings: false,
  bluebook_ui: false,
  world_language_player: false,
  set_student_app_cues: false,
  world_language_ap_reader: false,
  assignments_overview_info_panel: false,
  threeplay_plugin: false,
  immediate_feedback: false,
  generate_practice_quiz: false,
  use_new_grouped_actions: false,
  disable_lazy_load: false,
  enter_scores_expansion: false,
  new_assign_modal: false,
  allow_late_submission: false,
  bluebook_ui_highlight_enabled: false,
  new_assign_modal_cas_button: false,
  updated_timer_controls: false,
  student_player_defer_render: true,
  afam_ep26_full_launch_p1: false,
};

export const flagListWithConfig = {
  student_cb_alert: {
    treatment: false,
    config: {},
  },
  maintenance_page: {
    treatment: false,
    config: {},
  },
};

const sort_object_by_keys = (new_obj) =>
  Object.keys(new_obj)
    .sort()
    .reduce((obj, key) => {
      obj[key] = new_obj[key];
      return obj;
    }, {});

const featureFlag = (
  state = { ...flagList, ...flagListWithConfig },
  action,
) => {
  switch (action.type) {
    case types.SET_FEATURE_FLAG:
      // javascript in the browser shows keys in the order of entry just sorting the object so its easier to hunt down
      // values in redux devtools
      return sort_object_by_keys({
        ...state,
        ...action.payload.flags,
      });
    default:
      return state;
  }
};

export default featureFlag;
